import React from 'react';
import { Button } from '@/components/display/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-light-svg-icons';

type Props = {
  setIsAdding: () => void;
};

export function NewLineItemButton({ setIsAdding }: Props) {
  return (
    <>
      <Button onClick={setIsAdding} size="compact">
        <div className="flex items-center gap-2">
          <FontAwesomeIcon icon={faCirclePlus} />
          <div>Add Line Item</div>
        </div>
      </Button>
    </>
  );
}
